// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-video-view{width:100%;border-radius:16px;border:1px solid var(--background--spacer)}.c-video-view--not-delivered{border:1px solid #dfa51d}.c-video-view-container{position:relative;background:rgba(0,0,0,0);border:none}.c-video-view__play{position:absolute;left:40%;top:32%}.c-video-view__play-body{width:45px;height:45px}@media(min-width: 768px){.c-video-view__play-body{width:60px}}.c-video-view__play-body svg path{fill:var(--background--spacer)}", ""]);
// Exports
module.exports = exports;
